 <ion-card *ngIf="enlargeImage" class="fullscreen-overlay">
  <ion-row>
    <ion-col size="12">
      <ion-icon name="close-circle" class="font2" color="danger" (click)="enlargeImage=null"></ion-icon>
      <ion-col size="12" class="scrollable">
        <img [src]="enlargeImage" width="100%" height="auto">
      </ion-col>
    </ion-col>
  </ion-row>
</ion-card>
<ion-card class="employeeCard" [ngStyle]="{'background-color': theme}" *ngIf="!enlargeImage">
  <ion-row class="rowDisplay" (click)="mergeUser.emit(emp)">
    <ion-col size="1.5" sizeMd="0.5" class="padding5">
      <img [src]="emp.user.url || (emp.user.gender === 'MALE' ? './assets/imgs/male.png' : './assets/imgs/female.png')"
        alt="Photo" class="img" (click)="enlargeImage=emp.user.url" />
    </ion-col>
    <ion-col size="10.5" sizeMd="4" class="rowDisplay">
      <span class="padding5" *ngIf="emp.user.user_pd.death_date"> Late. </span>
      {{emp.user.name}} Ji
      <b>&nbsp;{{emp.user.user_pd.sub_community}}</b>
      &nbsp;({{emp.user.dob | age}})
      <ion-icon name="male-outline" color="tertiary" class="font1_5 padding5"
        *ngIf="emp.user.gender=='MALE' && platform.width()>=platform.height()"></ion-icon>
      <ion-icon name="female-outline" color="danger" class="font1_5 padding5"
        *ngIf="emp.user.gender=='FEMALE' && platform.width()>=platform.height()"></ion-icon>
      <ion-icon
        [color]="emp.user.user_pd.status=='Joined'?'medium':emp.user.user_pd.status=='Rejected'?'danger':'success'"
        class="font1_5 padding5 " name="checkmark-circle" *ngIf="emp.user.user_pd.status"></ion-icon>
      <div>
        <span *ngIf="emp.assigned_area">{{emp.assigned_area}}</span>

        <ion-chip color="secondary" mode="ios" class="padding5"
          *ngIf="auth.loggedInEmployee.assigned_area && ((auth.loggedInEmployee.assigned_area+'').length>2) && emp.user.user_pd.status=='Joined'"
          (click)="empService.clickApprove(emp)">Verify
        </ion-chip>
      </div>

      <ion-icon name="ellipsis-vertical-outline" *ngIf="showMenu" class="font1_3 more-icon"
        (click)="clickUserMenu.emit(emp)"></ion-icon>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding5 font0_9 singleLine"
      *ngIf="emp.user.user_pd.privacy!='Hide Everything' || auth.loggedInEmployee.designation">
      <b color="primary" mode="ios">{{emp.user.user_pd.origin_city}}</b> {{emp.user.user_pd.current_address2}}
    </ion-col>
    @if(emp.user.user_pd.education || emp.user.user_pd.occupation || emp.user.user_pd.profession || emp.user.user_pd.blood) {
    <ion-col size="3.5" sizeMd="1" class="padding5 singleLine"
      *ngIf="(emp.user.user_pd.privacy!='Hide Everything' || auth.loggedInEmployee.designation)">
      {{emp.user.user_pd.education}}
    </ion-col>

    <ion-col size="3.5" sizeMd="1" class="padding5 singleLine"
      *ngIf="(emp.user.user_pd.privacy!='Hide Everything' || auth.loggedInEmployee.designation)">
      {{emp.user.user_pd.occupation}}
    </ion-col>

    <ion-col size="3.5" sizeMd="1" class="padding5 singleLine"
      *ngIf="(emp.user.user_pd.privacy!='Hide Everything' || auth.loggedInEmployee.designation)">
      {{emp.user.user_pd.profession}}
    </ion-col>
    <ion-col size="1.5" sizeMd="0.5" class="bold bgLightGrey"
      *ngIf="(emp.user.user_pd.privacy!='Hide Everything' || auth.loggedInEmployee.designation)">
      {{emp.user.user_pd.blood}}
    </ion-col>
    }
  </ion-row>
</ion-card>